import { render } from "./Okved.vue?vue&type=template&id=7a398318&scoped=true"
import script from "./Okved.vue?vue&type=script&lang=js"
export * from "./Okved.vue?vue&type=script&lang=js"

import "./Okved.vue?vue&type=style&index=0&id=7a398318&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a398318"]])

export default __exports__